/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const pullLeft = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M4 18h6V6H4v12zm9-9.5V10h7V8.5h-7zm0 7h7V14h-7v1.5z" />
	</SVG>
);

export default pullLeft;
